import React from 'react';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import MuiTablePagination from '@mui/material/TablePagination';
import { withStyles } from 'tss-react/mui';
import { Pagination, Stack } from '@mui/material';

const defaultFooterStyles = {};

class CustomFooter extends React.Component {
  handleRowChange = (event) => {
    this.props.changeRowsPerPage(event.target.value);
  };

  handlePageChange = (_, page) => {
    this.props.changePage(page);
  };

  render() {
    const {
      count,
      textLabels,
      rowsPerPage,
      page,
      rowsPerPageOptions,
      totalPages,
      onChange,
      currentPage,
    } = this.props;

    const footerStyle = {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '0px 24px 0px 24px',
    };

    return (
      <TableFooter>
        <TableRow>
          <TableCell align="right">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={onChange}
                color="primary"
              />
            </Stack>
          </TableCell>
          <TableCell style={footerStyle}>
            {/* <button>Custom Option</button> */}
            <MuiTablePagination
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              labelRowsPerPage={textLabels.rowsPerPage}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${textLabels.displayRows} ${count}`
              }
              backIconButtonProps={{
                'aria-label': textLabels.previous,
              }}
              nextIconButtonProps={{
                'aria-label': textLabels.next,
              }}
              rowsPerPageOptions={rowsPerPageOptions ?? [10, 30, 50]}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handleRowChange}
            />
          </TableCell>
        </TableRow>
      </TableFooter>
    );
  }
}

export default withStyles(CustomFooter, defaultFooterStyles, {
  name: 'CustomFooter',
});
